import react, { useEffect } from 'react';
import { FancyWrapper, FancyBoxWrapper } from './style';

export interface IFancyProps {
  children: JSX.Element;
}

const FancyContent = ({ children }: IFancyProps) => {
  return (
    <FancyWrapper>
      <FancyBoxWrapper>{children}</FancyBoxWrapper>
    </FancyWrapper>
  );
};

export default FancyContent;
